<template>
  <div class="storage">
    <div class="heard">
      <router-link to="/xingHanDaPing">
        <div class="img">
          <img src="../../../../assets/dapingImg/logo.png" alt />
        </div>
      </router-link>
      <span class="title">仓储业务</span>
      <div class="date">
        <span>{{ nowDate + ' ' + nowWeek }}</span>
      </div>
    </div>

    <div class="storagemain">
      <el-row :gutter="24">
        <!-- 左侧 -->
        <el-col :span="7">
          <div class="grid-content bg-purple">
            <div class="left">
              <div class="left_h">
                <span class="span_one">出入库记录</span>
                <span class="span_two">单位(吨)</span>
              </div>
              <!-- <div class="left_heard">出入库数据</div> -->
              <div class="left_table">
                <div id="table">
                  <div class="tables">
                    <span class="span_one1">钢卷号</span>
                    <!-- <span class="span_one">材质</span> -->
                    <span class="">重量(吨)</span>
                    <!-- <span class="">规格</span> -->
                    <span class="">操作</span>
                    <span class="">操作人</span>
                    <span class="span_one2 one">时间</span>
                  </div>
                  <vue-seamless-scroll :data="churutableData" class="seamless-warp" @mouseenter.native="mouseenter" @mouseleave.native="mouseleave">
                    <ul class="item">
                      <li
                        id="li"
                        v-for="(item,index) in churutableData"
                        :key="index"
                        ref="liClass"
                        :style="item.useTimes>120?'color:red':item.useTimes>60?'color:yellow':''"
                      >
                        <span v-text="item.cargoBarcode" class="span1"></span>
                        <!-- <span v-text="item.material"></span> -->
                        <span v-text="item.weight"></span>
                        <!-- <span v-text="item.specs"></span> -->
                        <span>{{item.type==1?"入库":"出库"}}</span>
                        <span v-text="item.operator"></span>
                        <span  class="span2">{{item.operationTime | formatDate}}</span>
                      </li>
                    </ul>
                  </vue-seamless-scroll>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <!-- 中间 -->
        <el-col :span="10">
          <div class="grid-content bg-purple center">
            <div class="left_one">
              <div class="block">
                <el-carousel height="50vh" indicator-position="none"  @change="carouselChange"  :interval="10000"  :autoplay="autoplay">
                  <el-carousel-item v-for="(item,index) in cangkuTableData" :key="index" >
                    <div class="left_h">
                      <span class="span_one">{{ item.warehouseName }}</span>
                      <span class="span_two">单位(吨）</span>
                    </div>
                    <!-- 库存量 -->
                    <div class="left_main">
                      <div class="number">
                        <span>
                          库存量
                          <b>{{ item.storge }}</b>
                        </span>
                      </div>
                      <!-- 热卷 -->
                      <div class="hot">
                        <div :id="'pieChart'+index" class="pieChart"></div>
                      </div>
                      <div class="stock">
                        <ul>
                          <li>
                            <b class="b_r">{{item.dailyInStorage}}</b>
                            <br />
                            <span>日入库量</span>
                          </li>
                          <li>
                            <b class="b_c">{{item.dailyOutStorage}}</b>
                            <br />
                            <span>日出库量</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
            <div class="left_two">
              <div class="map">
                <div class="left_h">
                  <span class="span_one">日出入库量波动</span>
                  <span class="span_two">单位(吨)</span>
                </div>
                <div>
                  <!--为echarts准备一个具备大小的容器dom-->
                  <div id="idChart" class="idChart"></div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <!-- 右侧 -->
        <el-col :span="7">
          <div class="grid-content bg-purple">
            <div class="left_one">
              <div class="left_h">
                <span class="span_one">仓库统计</span>
                <span class="span_two">单位(吨)</span>
              </div>
              <div class="left_table" style=" height: 41vh;">
                <div id="table">
                  <div class="tables">
                    <span class="span_one">仓库名称</span>
                    <span class="span_one" style="width:30%">当前库存(吨)</span>
                  </div>
                  <vue-seamless-scroll :data="cangkuTableData" class="seamless-warp">
                    <ul class="item">
                      <li v-for="(item,index) in cangkuTableData" :key="index">
                        <span class="span" v-text="item.warehouseName"></span>
                        <span class="span" style="width:30%">{{item.storge}}</span>
                      </li>
                    </ul>
                  </vue-seamless-scroll>
                </div>
              </div>
            </div>
            <div class="left_two">
               <div class="left_h">
                  <span class="span_one">提货转货统计</span>
                  <span class="span_two">单位(吨)</span>
              </div>
              <div id="zhu" style="height:40vh"></div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import dateFormat from '../../../../utils/Date'
import {
  getSocWarehouseList,
  getSocBillWaveList
} from '@/api/data-center-server'
export default {
  data () {
    return {
      nowDate: '', // 当前日期
      nowTime: '', // 当前时间
      nowWeek: '', // 当前星期
      charts: '',
      seerr: '',
      mapTimer: '',
      timer: '',
      inOutDataIndex: 0,
      inOutDateData: [], // 出入库时间
      inData: [], // 入库值
      outData: [], // 出库库值
      churutableData: [], // 出入库数据
      kehuTableData: [], // 客户统计
      cangkuTableData: [], // 仓库实时数据
      bodongTableData: [], // 波动数据,
      autoplay: true
    }
  },
  created () {},
  mounted () {
    this.cangkuDataS() // 仓库实时数据
    this.tihuozhuanhuo()// 提货转货统计
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    } else {
      this.timer = setInterval(() => {
        this.cangkuDataS() // 仓库实时数据
        this.tihuozhuanhuo()// 提货转货统计
      }, 1000 * 60 * 2)
    }
  },
  updated () {},
  // 销毁定时器
  beforeDestroy: function () {
    if (this.getDate) {
      clearInterval(this.getDate) // 在Vue实例销毁前，清除时间定时器
    }
  },
  methods: {
    //
    mouseleave () {
      this.autoplay = true
    },
    mouseenter () {
      this.autoplay = false
    },
    // 提货转货统计
    tihuozhuanhuo () {
      getSocBillWaveList({})
        .then(res => {
          // 柱状图数据
          var map4Data1 = []
          var map4Data2 = []
          this.nameData = []
          res.forEach((item, index) => {
            this.nameData.push(dateFormat(item.date))
            map4Data1.push(item.pickWeight)
            map4Data2.push(item.transWeight)
          })
          let myChart = this.$echarts.init(document.getElementById('zhu'))

          // 绘制图表--柱状
          myChart.setOption({
            color: ['#0DD9FE', '#52F23A'],
            // backgroundColor: "#323a5e",
            grid: {
              left: '2%',
              right: '4%',
              bottom: '9%',
              top: '25%',
              containLabel: true
            },
            legend: {
              icon: 'circle',
              data: ['提货量', '转货量'],
              textStyle: {
                color: '#fff'
              }
            },
            // ---  提示框 ----
            tooltip: {
              show: true, // 是否显示提示框，默认为true
              trigger: 'item', // 数据项图形触发
              axisPointer: {
                // 指示样式
                type: 'shadow',
                axis: 'auto'
              },
              formatter: function (value) {
                return value.marker + value.seriesName + '：' + value.value
              },
              padding: 5,
              textStyle: {
                // 提示框内容的样式
                color: '#fff'
              }
            },
            calculable: true,
            xAxis: {
              type: 'category',
              data: this.nameData,
              axisLine: {
                lineStyle: {
                  color: 'white'
                }
              },
              axisLabel: {
                // interval: 0,
                // rotate: 40,
                textStyle: {
                  fontFamily: 'Microsoft YaHei'
                }
              }
            },
            yAxis: {
              type: 'value',
              data: ['2000', '4000', '6000', '8000'],
              axisLine: {
                show: false,
                lineStyle: {
                  color: 'white'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: 'rgba(255,255,255,0.3)'
                }
              },
              axisLabel: {}
            },
            series: [
              {
                name: '提货量',
                type: 'bar',
                barGap: 0,
                barWidth: '15%',
                data: map4Data1
              },
              {
                name: '转货量',
                type: 'bar',
                barGap: 0,
                barWidth: '15%',
                data: map4Data2
              }
            ]
          })
        })
        .catch(err => {
          console.log(err)
        })
      function dateFormat (data) {
        var t = new Date(data) // row 表示一行数据, transferTime 表示要格式化的字段名称
        var month =
    t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
        var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
        var str = ''
        if (data == null || data == '') {
          str = '--'
        } else {
          str =
          month +
          '.' +
          date
        }
        return str
      }
    },
    // 出入库波动
    bodongDataS (data) {
      let inData = []
      let outData = []
      let DateData = []
      data.forEach(item => {
        inData.push(item.dailyInStorage)
        outData.push(item.dailyOutStorage)
        DateData.push(dateFormat(item.statisticalDate))
      })
      let _this = this
      let idChart = _this.$echarts.init(document.getElementById('idChart'))
      // 绘制图表--折线图
      var idChartOption = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['日入库量', '日出库量'],
          color: ['#fff'],
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          left: '6%',
          right: '8%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: DateData,
          // 横坐标轴颜色
          axisLine: {
            lineStyle: {
              color: '#14D5FF'
            }
          }
        },
        yAxis: {
          type: 'value',
          max: '50000',
          // 横坐标轴颜色
          axisLine: {
            lineStyle: {
              color: '#14D5FF'
            }
          },
          splitLine: {
            lineStyle: {
              color: '#14D5FF'
            }
          }
        },
        series: [
          {
            name: '日入库量',
            type: 'line',
            color: '#E09C13',
            data: inData
          },
          {
            name: '日出库量',
            type: 'line',
            color: '#3BE232',
            data: outData
          }
        ]
      }
      idChart.setOption(idChartOption)
      function dateFormat (data) {
        var t = new Date(data) // row 表示一行数据, transferTime 表示要格式化的字段名称
        var month =
    t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
        var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
        var str = ''
        if (data == null || data == '') {
          str = '--'
        } else {
          str =
          month +
          '.' +
          date
        }
        return str
      }
    },
    // 幻灯片切换
    carouselChange (index) {
      if (this.cangkuTableData.length > 0) {
        this.churutableData = this.cangkuTableData[index].inoutRecordList
        this.bodongDataS(this.cangkuTableData[index].wavelist)
      }
    },
    // 实时数据 个仓库货物数据
    async cangkuDataS () {
      await getSocWarehouseList({})
        .then(res => {
          this.cangkuTableData = res
        })
        .catch(err => {
          console.log(err)
        })
      var dataStyle = {
        normal: {
          label: {
            show: false
          },
          labelLine: {
            show: false
          },
          shadowBlur: 0,
          shadowColor: '#203665'
        }
      }
      if (this.cangkuTableData.length > 0) {
        this.cangkuTableData.forEach((item, index) => {
        // 绘制图表-圆形
          let pieChart = this.$echarts.init(
            document.getElementById('pieChart' + index)
          )
          pieChart.setOption({
            backgroundColor: 'rgba(255,255,255,0)',
            series: [
              {
                name: '第一个圆环',
                type: 'pie',
                clockWise: false,
                radius: [55, 70],
                itemStyle: dataStyle,
                hoverAnimation: false,
                center: ['12%', '50%'],
                data: [
                  {
                    value: item.coldRoll,
                    label: {
                      normal: {
                        rich: {
                          a: {
                            color: '#14D5FF',
                            align: 'center',
                            fontSize: 16,
                            fontWeight: 'bold'
                          },
                          b: {
                            color: '#14D5FF',
                            align: 'center',
                            fontSize: 12
                          }
                        },
                        formatter: function (params) {
                        // return '{a|' + item.heatNum + '}' + '\n\n热卷库存'
                          return '{a|' + item.coldRoll + '}' + '\n\n冷卷'
                        },
                        position: 'center',
                        show: true,
                        textStyle: {
                          fontSize: '12',
                          fontWeight: 'normal',
                          color: '#fff'
                        }
                      }
                    },
                    itemStyle: {
                      normal: {
                        color: '#14D5FF',
                        shadowColor: '#2c6cc4',
                        shadowBlur: 0
                      }
                    }
                  },
                  {
                    value: item.storge - item.coldRoll,
                    name: 'invisible',
                    itemStyle: {
                      normal: {
                        color: '#24375c'
                      },
                      emphasis: {
                        color: '#24375c'
                      }
                    }
                  }
                ]
              },
              {
                name: '第二个圆环',
                type: 'pie',
                clockWise: false,
                radius: [55, 70],
                itemStyle: dataStyle,
                hoverAnimation: false,
                center: ['37%', '50%'],
                data: [
                  {
                    value: item.hotRoll,
                    label: {
                      normal: {
                        rich: {
                          a: {
                            color: '#FE4830',
                            align: 'center',
                            fontSize: 16,
                            fontWeight: 'bold'
                          },
                          b: {
                            color: '#fff',
                            align: 'center',
                            fontSize: 12
                          }
                        },
                        formatter: function (params) {
                        // return '{a|' + item.coldNum + '}' + '\n\n冷卷库存'
                          return '{a|' + item.hotRoll + '}' + '\n\n热卷'
                        },
                        position: 'center',
                        show: true,
                        textStyle: {
                          fontSize: '12',
                          fontWeight: 'normal',
                          color: '#fff'
                        }
                      }
                    },
                    itemStyle: {
                      normal: {
                        color: '#FE4830',
                        shadowColor: '#ef45ac',
                        shadowBlur: 0
                      }
                    }
                  },
                  {
                    value: item.storge - item.hotRoll,
                    name: 'invisible',
                    itemStyle: {
                      normal: {
                        color: '#24375c'
                      },
                      emphasis: {
                        color: '#24375c'
                      }
                    }
                  }
                ]
              },
              {
                name: '第三个圆环',
                type: 'pie',
                clockWise: false,
                radius: [55, 70],
                itemStyle: dataStyle,
                hoverAnimation: false,
                center: ['62%', '50%'],
                data: [
                  {
                    value: item.thickPlate,
                    label: {
                      normal: {
                        rich: {
                          a: {
                            color: '#FBAE00',
                            align: 'center',
                            fontSize: 16,
                            fontWeight: 'bold'
                          },
                          b: {
                            color: '#fff',
                            align: 'center',
                            fontSize: 12
                          }
                        },
                        formatter: function (params) {
                        // return '{a|' + item.plateNum + '}' + '\n\n中厚板库存'
                          return '{a|' + item.thickPlate + '}' + '\n\n中厚板'
                        },
                        position: 'center',
                        show: true,
                        textStyle: {
                          fontSize: '12',
                          fontWeight: 'normal',
                          color: '#fff'
                        }
                      }
                    },
                    itemStyle: {
                      normal: {
                        color: '#FBAE00',
                        shadowColor: '#613fd1',
                        shadowBlur: 0
                      }
                    }
                  },
                  {
                    value: item.storge - item.thickPlate,
                    name: 'invisible',
                    itemStyle: {
                      normal: {
                        color: '#24375c'
                      },
                      emphasis: {
                        color: '#24375c'
                      }
                    }
                  }
                ]
              },
              {
                name: '第四个圆环',
                type: 'pie',
                clockWise: false,
                radius: [55, 70],
                itemStyle: dataStyle,
                hoverAnimation: false,
                center: ['87%', '50%'],
                data: [
                  {
                    value: item.buildingSteel,
                    label: {
                      normal: {
                        rich: {
                          a: {
                            color: '#FBAE00',
                            align: 'center',
                            fontSize: 16,
                            fontWeight: 'bold'
                          },
                          b: {
                            color: '#fff',
                            align: 'center',
                            fontSize: 12
                          }
                        },
                        formatter: function (params) {
                        // return '{a|' + item.plateNum + '}' + '\n\n中厚板库存'
                          return '{a|' + item.buildingSteel + '}' + '\n\n 建材钢'
                        },
                        position: 'center',
                        show: true,
                        textStyle: {
                          fontSize: '12',
                          fontWeight: 'normal',
                          color: '#fff'
                        }
                      }
                    },
                    itemStyle: {
                      normal: {
                        color: '#4aec45',
                        shadowColor: '#613fd1',
                        shadowBlur: 0
                      }
                    }
                  },
                  {
                    value: item.storge - item.thickPlate,
                    name: 'invisible',
                    itemStyle: {
                      normal: {
                        color: '#24375c'
                      },
                      emphasis: {
                        color: '#24375c'
                      }
                    }
                  }
                ]
              }
            ]
          })
        })
      }
    }
  },
  filters: {
    formatDate (time) {
      let date = new Date(time)
      return dateFormat.formatDate(date, 'MM.dd hh:mm')
    }
  },
  computed: {
    optionSingleHeightTime () {
      return {
        // singleHeight: 26,
        // waitTime: 2500,
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: this.kehuTableData.length, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1200 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  destroyed () {
    clearInterval(this.timer, this.mapTimer)
  }
}
</script>

<style lang="less" scoped>
.heard {
  width: 100%;
  height: 6vh;
  line-height: 6vh;
  display: flex;
  background: url("../../../../assets/dapingImg/标题光条.png") no-repeat;
  background-size: 100% 100%;
  text-align: center;
  .title {
    flex: 1;
    font-size: 30px;
    font-weight: 700;
    color: #03faec;
  }
  .date {
    font-size: 16px;
    color: #ffdd17;
  }
   .img{
    height: 6vh;
    img{
      height: 100%;
    }
  }
}
.seamless-warp {
  overflow: hidden;
  ul {
   margin: 0;
   padding: 0;
// margin-top: 10px;
  }
  li {
    display: flex;
    width: 100%;
    height: 4vh;
    line-height: 4vh;
    color: #3fd2ff;
 display: -webkit-flex;
          -webkit-flex-direction:row;
    span {
      // flex: 1;
      width:20%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      // padding: 0 2px;
      text-align: center;
    }
    .span1{
       width:40%;
    }
    .span2{
       width:35%;
    }
    .span3{
       width:70% !important;
    }
    .span {
      // flex: 1;
      width:50%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .colorYellow {
    // border: 1px solid yellow;
    color: #eed808;
  }
}
.left_h {
  height: 30px;
  line-height: 30px;
  color: #03faec;
  // font-weight: 700;
  font-size: 20px;
  background: url("../../../../assets/dapingImg/mk-title-bg.png") no-repeat;
  background-size: 100% 100%;
  .span_one {
    float: left;
    margin-left: 10px;
    font-size: 16px;
  }
  .span_two {
    float: right;
    margin: 5px;
    font-size: 16px;

    font-weight: normal;
  }
}

.map_heard {
  color: #03faec;
  font-weight: 700;
  font-size: 35px;
  position: absolute;
  left: 46%;
  top: 30px;
}
.storagemain {
  width: 100%;
  height: 100%;
  position: relative;
}

.storage {
  height: 100vh;
  width: 100%;
  overflow: hidden;
  // padding: 0 29px;
  background: url("../../../../assets/dapingImg/bg.png") 100%;
}
.left {
  // background-color: #ccc;
  padding: 0px 0px 0px 1px;
  box-sizing: border-box;
  height: 90vh;
  width: 100%;
  background: url("../../../../assets/dapingImg/bg1.png") no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  // overflow-x: scroll;
}
.left_two {
  //折线图
  // background-color: #ccc;
  padding: 0px 0px 0px 1px;
  box-sizing: border-box;
  height: 44vh;
  overflow: hidden;
  width: 100%;
  background: url("../../../../assets/dapingImg/bg1.png") no-repeat;
  background-size: 100% 100%;
  // overflow-x: scroll;
}
.left_one {
  //轮播
  // background-color: #ccc;
  padding: 0px 0px 0px 1px;
  box-sizing: border-box;
  height: 45vh;
  margin-bottom: 10px;
  width: 100%;
  background: url("../../../../assets/dapingImg/bg1.png") no-repeat;
  background-size: 100% 100%;

  // overflow-x: scroll;
}
.right {
  li {
    height: 55px;
    line-height: 55px;
  }
}
.right_hour {
  color: red;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
.center_heard {
  font-size: 30px;
  font-weight: 700;
  text-align: center;
  height: 60px;
  line-height: 60px;
}

.left_main {
  height: 300px;
  text-align: center;
  .number {
    height: 6vh;
    line-height: 6vh;
    color: #fff;
    font-size: 18px;
    b {
      font-size: 25px;
      margin-left: 10px;
    }
  }
  .stock {
    height: 4vh;
    width: 100%;
    // background-color: pink;
    // position: absolute;
    // top: 15vh;
    // bottom: 0;
    // bottom: 3vh;
    // left: 0;
    font-size: 16px;
    ul {
      height: 8vh;
      overflow: hidden;
      // background: url("../../../../assets/dapingImg/bg1.png") no-repeat;
      // background-size: 100% 100%;
      display: flex;
      margin: 0;
      padding: 0;
      li {
        flex: 1;
        text-align: center;
        margin: 0;
        padding: 0;
        // margin-left: 55px;
      }
      // 日入
      .b_r {
        font-size: 20px;
        color: #eed808;
      }
      // 日出
      .b_c {
        font-size: 20px;
        color: #4aec45;
      }
      p {
        margin: 0;
      }
      span {
        color: #fff;
      }
    }
  }
  .hot {
    width: 100%;
    // height: 100%;
  }
  ul {
    display: flex;
    margin-top: 25px;
  }
  li {
    flex: 1;
    // background-color: #fff;
    list-style: none;
    // height: 80px;
    width: 25%;
    margin-left: 5px;
    margin-right: 5px;
    text-align: center;
    padding-top: 10px;
    box-sizing: border-box;
    span {
      font-weight: 700;
    }
  }
}
.left_heard {
  color: #fff;
  font-weight: 700;
  //   text-align: center;
  //   margin-left: 20px;
  line-height: 60px;
  width: 100%;
  height: 60px;
  // background-color: #1a85e1;
}
.left_table {
  width: 100%;
  height: 85vh;
  overflow: hidden;
  .tables {
    background-color: #0565f7;
    width: 100%;
    color: #fff;
    height: 5vh;
    line-height: 5vh;
    display: flex;
    text-align: center;
    span {
      // flex: 1;
      width: 17%;
    }
    .span_one {
      // flex: 1;右侧
      width: 50%;
    }
    .span_one3 {
      // flex: 1;客户
      width: 80%;
    }
    .span_one1 {
      // flex: 1; 钢卷
      width: 40%;
    }
    .span_one2 {
      // flex: 1;时间
      width: 35%;
    }
  }
  .table_li {
    ul {
      height: 45px;
      // background-color: rgb(58, 72, 88);
      li {
        line-height: 45px;
        list-style: none;
        color: #14d5ff;
      }
    }
  }
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.pieChart {
  width: 100%;
  height: 25vh !important;
}
.idChart {
  width: 100%;
  height: 40vh;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  // background-color: #f9fafc;
}
</style>
